import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RenderIf } from 'syf-component-library/ui/atoms';
import useTranslation from '../../../hooks/use-translation';
import useTriggerAnalyticsEvent from '../../../hooks/use-trigger-analytics-event';
import { StyledTableTitle } from '../../common/table-list/subcomponents';
import TermDetailsAccordion from '../../common/term-details-accordion';
import Card from '../card';
const Mobile = ({ activePromotions, expiredPromotions, showDetailsModal, isModalOpen }) => {
    const t = useTranslation();
    const promotions = [
        {
            id: 'active',
            heading: t('promotions.activePromotionsHeading'),
            promotions: activePromotions
        },
        {
            id: 'expired',
            heading: t('promotions.expiredPromotionsHeading'),
            promotions: expiredPromotions
        }
    ];
    useTriggerAnalyticsEvent('promoCenterTab.promotions', {
        active: activePromotions,
        expired: expiredPromotions
    }, !isModalOpen);
    return (_jsxs(_Fragment, { children: [promotions.map(promotionType => (_jsx(RenderIf, { condition: promotionType.promotions.length !== 0, children: _jsxs(_Fragment, { children: [_jsx(StyledTableTitle, { children: promotionType.heading }), promotionType.promotions.map((promotion) => (_jsx(Card, { promotion: promotion, showDetailsModal: showDetailsModal }, `${promotion.description}-${promotion.remainingBalance}`)))] }) }, promotionType.id))), _jsx(TermDetailsAccordion, { header: t('promotions.accordionHeading'), text: t('promotions.accordionText'), isCollapsed: true })] }));
};
export default Mobile;
//# sourceMappingURL=index.js.map